import React from 'react';
import Select from 'components/ui/Select';

const VerificationFilter = ({ onFilter, currentFilter }) => {
  const verificationOptions = [
    { value: 'all', label: 'Tutti gli stati di verifica' },
    { value: 'pending', label: 'In Attesa' },
    { value: 'approved', label: 'Approvati' },
    { value: 'rejected', label: 'Rifiutati' }
  ];

  return (
    <Select
      value={currentFilter}
      onChange={(value) => onFilter(value)}
      options={verificationOptions}
      className="w-full"
    />
  );
};

export default VerificationFilter;